import React from 'react';
import { Box, Skeleton, TableRow, TableCell } from '@mui/material';
import PropTypes from 'prop-types';

const TableSkeletonRows = ({ numberOfRows = 3, numberOfColumns = 6 }) => {
  return Array(numberOfRows)
    .fill(0)
    .map((_, rowIndex) => (
      <TableRow key={rowIndex}>
        {Array(numberOfColumns)
          .fill(0)
          .map((_, colIndex) => (
            <TableCell key={colIndex}>
              <Box sx={{ p: 1 }}>
                <Skeleton animation="wave" width="100%" />
              </Box>
            </TableCell>
          ))}
      </TableRow>
    ));
};

TableSkeletonRows.propTypes = {
  numberOfRows: PropTypes.number,
  numberOfColumns: PropTypes.number,
};

export default TableSkeletonRows;